import { cateringOrderClient } from '@/services/clients'

export default {
  getPopularBuilds() {
    return cateringOrderClient.get('/popularbuild')
  },
}
